import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { provideDarkTheme, remoteConfigProviders } from '@softline/application';
import {
  accountContextProviders,
  contextSettingsProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders, vkforgContextProviders,
} from '@softapps/allgemein/utils';
import { passwordProviders } from '@softapps/allgemein/password';
import { loginProviders, withLogin } from '@softapps/allgemein/login';
import { moduleProviders } from '@softapps/allgemein/modules';
import { wwsCoreProviders } from '@softapps/wws/core';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { inventurProviders } from '@softapps/mde/inventur';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
import { retourenProviders } from '@softapps/mde/retouren';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { platform } from '../platforms/platform';
import { stempelerfassungProviders } from '@softapps/pms/stempelerfassung';
import {
  provideSoftApps,
  SOFTLINE_ROUTES_APPS,
  SOFTLINE_ROUTES_PUBLIC,
} from '@softapps/core';
import { artikelvorratProviders } from '@softapps/mde/artikelvorrat';
import { materiallieferscheinScanProviders } from '@softapps/mde/materiallieferschein-scan';
import { publicRoutes, shellRoutes } from './app.routes';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import { gesamtabfrageProviders } from '@softapps/wws/gesamtabfrage';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([]),
    provideSoftApps({ connection: environment.connection }, withLogin()),

    provideDarkTheme(false),

    { provide: SOFTLINE_ROUTES_APPS, useValue: shellRoutes, multi: true },
    { provide: SOFTLINE_ROUTES_PUBLIC, useValue: publicRoutes, multi: true },

    /*
    importProvidersFrom(
      BrowserAnimationsModule,
      RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' }),

      // Framework
      CoreModule.forRoot(),
      StoreModule.forRoot(),
      ConnectionModule.forRoot(environment.connection),
      AuthenticationModule.forRoot(),
      JwtAuthenticationModule.forRoot(),
      AuthorizationModule.forRoot(),
      ApplicationModule.forRoot(),
      AppearanceModule.forRoot(),
      DynamicModule.forRoot(),
      MasterDataModule.forRoot(),
      DeveloperModule.forRoot(),
      ConsoleModule.forRoot(),
      ItemScanModule.forRoot(),
      OfflineModule.forRoot(),
      SoftappsCoreModule.forRoot()
    ),*/

    // Allgemein
    ...utilitiesProviders,
    ...contextSettingsProviders,
    ...userContextProviders,
    ...accountContextProviders,
    ...vkforgContextProviders,

    ...settingsProviders,
    ...remoteConfigProviders,
    ...passwordProviders,
    ...loginProviders,
    ...moduleProviders,

    //Wws
    ...gesamtabfrageProviders,
    // ...stempelerfassungProviders,

    // MDE
    ...wwsCoreProviders,
    ...stempelerfassungProviders,
    // ...gesamtabfrageProviders,

    ...bestellvorschlagProviders,
    ...bestellerfassungProviders,
    ...etikettendruckProviders,
    ...inventurProviders,
    ...warenverprobungProviders,
    ...retourenProviders,
    ...artikelvorratProviders,
    ...materiallieferscheinScanProviders,
    ...provideStorageLocation(),

    ...artikelInfoProviders,

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
